import { BoxProps } from 'UIKit/Box/types'
import { InhouseGameDetails } from 'config/types/game'
import { StyledGameBoard } from 'views/InhouseGame/components/styled'
import { GameInHouseConfig } from 'views/InhouseGame/config/types'
import LimboGameResult from './components/LimboGameResult'
import LimboGameTargetConfig from './components/LimboGameTargetConfig'
import LimboResultHistory from './components/LimboResultHistory'

const GameBoard: React.FC<
  {
    disabled?: boolean
    game: InhouseGameDetails
    targetMultiplier: string
    onTargetMultiplierChanged: (value: string) => void
  } & GameInHouseConfig &
    BoxProps
> = ({ onTargetMultiplierChanged, targetMultiplier, volumeEnable, disabled, game, ...props }) => {
  return (
    <StyledGameBoard height="100%" {...props}>
      <LimboResultHistory game={game} />
      <LimboGameResult volumeEnable={volumeEnable} />
      <LimboGameTargetConfig
        disabled={disabled}
        targetMultiplier={targetMultiplier}
        onTargetMultiplierChanged={onTargetMultiplierChanged}
      />
    </StyledGameBoard>
  )
}

export default GameBoard
